import React, { FC } from "react";

import { DefaultRowControl } from "~/shared/ui/TableV2/ui/DefaultRowControl";

import directoryRowActionsStyles from "~/pages/Directory/shared/DirectoryRowActions.less";

interface IBaseStaffTableRowControlsProps {
  record: Record<string, unknown>;
  rowKey: string;
  selected: boolean;
  onToggle: (rowKey: string, checked: boolean) => void;
  onViewDetails?: (record: Record<string, unknown>) => void;
  onRowEdit?: (record: Record<string, unknown>) => void;
}

const BaseStaffTableRowControls: FC<IBaseStaffTableRowControlsProps> = ({
  record,
  rowKey,
  selected,
  onToggle,
  onViewDetails,
  onRowEdit,
}) => (
  <div
    className={directoryRowActionsStyles.directoryRowActions}
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
  >
    {/* TODO PASDILER-2428: выбор строк для массовых действий временно скрыт до завершения работ в feat/PASDILER-1829. https://task.sotl.group:8443/browse/PASDILER-2428
    <RowSelectionControl
      checked={selected}
      onClick={() => onToggle(rowKey, !selected)}
    /> */}
    <DefaultRowControl
      record={record}
      onViewDetails={onViewDetails}
      onRowEdit={onRowEdit}
    />
  </div>
);

export default BaseStaffTableRowControls;
